import {
  RouteConfig
} from 'vue-router'
import Layout from '@/layout/index.vue'

const organizationRouter: RouteConfig = {
  path: '/ou',
  component: Layout,
  redirect: '/ou/departmentList',
  name: '机构管理',
  meta: {
    title: '机构管理'
  },
  children: [
    {
      path: 'organization',
      name: 'organization',
      component: () => import(/* webpackChunkName: "ou" */ '@/views/ou/adminUserManager.vue'),
      meta: {
        title: '子机构管理'
      }
    },
    {
      path: 'userManager',
      name: 'userManager',
      component: () => import(/* webpackChunkName: "ou-members" */ '@/views/ou/userManager.vue'),
      meta: {
        title: '机构成员管理'
      }
    },
    {
      path: 'departmentList',
      name: 'departmentList',
      component: () => import(/* webpackChunkName: "ou-departments" */ '@/views/ou/departmentList.vue'),
      meta: {
        title: '部门管理'
      }
    },
    {
      path: 'commentlist',
      name: 'ouCommentList',
      component: () => import(/* webpackChunkName: "ou-comment" */ '@/views/ou/commentList.vue'),
      meta: {
        title: '分店评价'
      }
    },
    {
      path:'ouWechatUserManager',
      name:'ouWechatUserManager',
      component: () => import(/* webpackChunkName: "ou-members" */ '@/views/ou/ouWechatUserManager.vue'),
      meta:{
        title:'会员管理'
      }
    }
  ]
}


export default organizationRouter
